<template>
  <the-modal @closeModal="$emit('close')" class="upload-helper-modal">
    <div class="flex justify-between items-center" slot="header">
      <h3>{{ $t('powerpointTemplate.upload.modal.help_modal.title') }}</h3>
      <div class="header-actions">
        <span class="text-xl fas fa-times" @click="$emit('close')"></span>
      </div>
    </div>

    <template #body>
      <div>
        <h4>{{ $t('powerpointTemplate.upload.modal.help_modal.file_upload_overview') }}</h4>

        <div class="content">
          <h5 class="font-semibold text-xl underline">{{ $t('powerpointTemplate.upload.modal.help_modal.uploading_files') }}</h5>
          <ul>
            <li>
              <div>{{ $t('powerpointTemplate.upload.modal.help_modal.upload_instruction') }}</div>
            </li>
          </ul>
        </div>
        <br>
        <div class="content">
          <h5 class="font-semibold text-xl underline">{{ $t('powerpointTemplate.upload.modal.help_modal.placeholder_syntax') }}</h5>
          <ul>
            <li>
              <div class="title">{{ $t('powerpointTemplate.upload.modal.help_modal.basic_placeholder_syntax') }}</div>
              <div>{{ $t('powerpointTemplate.upload.modal.help_modal.placeholder_description') }}</div>
              <div class="example">{{ $t('powerpointTemplate.upload.modal.help_modal.placeholder_example') }}</div>
            </li>
            <li>
              <div class="title">{{ $t('powerpointTemplate.upload.modal.help_modal.markers_syntax') }}</div>
              <div>{{ $t('powerpointTemplate.upload.modal.help_modal.markers_description') }}</div>
              <div>{{ $t('powerpointTemplate.upload.modal.help_modal.markers_placement') }}</div>
              <div class="example">{{ $t('powerpointTemplate.upload.modal.help_modal.markers_example') }}</div>
            </li>
          </ul>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="btn-container">
        <button class="btn btn-default btn-sm" @click="$emit('close')">
          {{ $t('confirmation.cancel') }}
        </button>
      </div>
    </template>
  </the-modal>
</template>

<script>
import TheModal from "../../modal.vue";

export default {
  name: "InfoModal",
  components: {
    TheModal,
  }
}
</script>
